<template>
    <section class='exit-info'>
        <h5>---出场信息---</h5>
<ul>
    <li>
        <span>出场时间</span>
        <span>{{exitInfo.endDate}}</span>
    </li>
    <li>
        <span>停车时长</span>
        <span>{{exitInfo.parkingLongTime}}</span>
    </li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
</ul>
    </section>
</template>
<script>
export default {
    name: 'exit-info',
    props: {   
        exitInfo: { 
            type: Object,
            default: () => {
                return {
                endDate: '2024--3-10 12:34:56',
                    parkingLongTime:'2小时30分30秒'
                }
            }
        }
}
}
</script>
<style scoped>
.exit-info {
    padding-bottom:20px;
    box-sizing: border-box;
    width: 45%;


}
h5{
    padding:10px 0;
    font-weight:bold;
}
ul{
    background: #eee;
    padding:10px;
    box-sizing: border-box;
    border-radius: 10px;
   
}
ul li{
    padding:5px 0;
    box-sizing: border-box;
}
ul li span:nth-child(1){
    display:inline-block;
     /* padding-right:10px;
    box-sizing: border-box; */
    width:90px;
    font-weight: bold;
}
ul li span:nth-child(2) {
    display:inline-block;
  color:#2a9df5;
  font-weight:bold;
}
</style>
